import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SurveySelectionPage } from './survey-selection';

@NgModule({
  declarations: [
    SurveySelectionPage,
  ],
  imports: [
    IonicPageModule.forChild(SurveySelectionPage),
  ]
})
export class SurveySelectionPageModule {}



// WEBPACK FOOTER //
// ./src/pages/survey-selection/survey-selection.module.ts